<template>
    <div>
        <vue-simple-header>
            <span slot="headerTitle">Wikis List</span>
            <div class="" slot="panelRight">
                <vue-folder-button
                        :no-text-on-mobile="true"
                        v-show="createWikiVisible"
                        @click.native="createWiki"
                        text="Create Wiki"
                        icon-class="fa-plus"
                ></vue-folder-button>
                <vue-search-input @search="onSearch" @cancel="onSearchCancel"></vue-search-input>
            </div>
        </vue-simple-header>

        <div class="row" v-if="isWikiUser&&myWikis.length&&!query">
            <div class="col-sm-12 list_header">
                My Wikis ({{myWikis.length}})
            </div>
        </div>
        <div class="row" v-if="isWikiUser&&myWikis.length&&!query">
            <div class="col-sm-12">
                <wikis-shared-list-wiki
                        :wiki="wiki"
                        :show-owner="false"
                        @changeWikiTemplate="changeWikiTemplate(wiki)"
                        v-for="wiki in myWikis"
                        :key="wiki.id"
                ></wikis-shared-list-wiki>
            </div>
        </div>

        <div class="row" v-show="wikis.length" v-if="managedItemsCount&&!sharedItemsCount">
            <div class="col-sm-12 list_header">
                Wikis I Manage ({{managedItemsCount}})
            </div>
        </div>

        <div class="row" v-show="wikis.length" v-if="!managedItemsCount&&sharedItemsCount">
            <div class="col-sm-12 list_header">
                Wikis shared with me ({{sharedItemsCount}})
            </div>
        </div>
        <div class="row" v-if="managedItemsCount&&sharedItemsCount">
            <div class="col-sm-12">
                <tabs justified v-model="tabIndex" @before-change="changeTab">
                    <tab>
                        <p slot="title" style='font-size: 19px; font-weight: bold;'>Wikis I Manage ({{managedItemsCount}})</p>
                    </tab>
                    <tab>
                        <p slot="title" style='font-size: 19px; font-weight: bold;'>Wikis shared with me ({{sharedItemsCount}})</p>
                    </tab>
                </tabs>
            </div>
        </div>

        <div class="row" v-infinite-scroll="loadMore">
            <div class="col-sm-12">
                <wikis-shared-list-wiki
                        @changeWikiTemplate="changeWikiTemplate(wiki)"
                        :wiki="wiki"
                        v-for="wiki in wikis"
                        :key="wiki.id"
                ></wikis-shared-list-wiki>
            </div>
        </div>
        <div class="row text-center" v-show="allLoaded&&wikis.length===0&&(query||(myWikis.length===0))">
            <div class="col-sm-12">
                <span style="font-size: 20px">No results...</span>
            </div>
        </div>
        <div class="text-center" v-if="loading"><span>Loading...</span></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import WikisSharedListWiki from "./WikisSharedListWiki";
    import InfiniteScrollMixin from "../../../vue/mixins/InfiniteScrollMixin";
    import {CurrentUserClass} from "../shared/CurrentUser";

    const CurrentUser = new CurrentUserClass();
    import {DjangoUrls} from 'DjangoUrls';
    import MyStuffListMyItem from "../../../vue/common_components/MyStuffListMyItem";
    import {DASHBOARD_ICONS, DASHBOARD_ITEMS} from "../dashboard/dashboard";
    import {getMainWikiPageName} from "./WikiChildrenPages";
    import {ROUTER_NAME_PREFIX} from "./config";

    export default {
        name: "WikisSharedList",
        components: {MyStuffListMyItem, WikisSharedListWiki},
        mixins: [InfiniteScrollMixin],
        data() {
            return {
                tabIndex: 0,
                getResultsOnMount: false,
                limit: 20,
                myWikiHref: CurrentUser.is_wiki_user ? `${DjangoUrls['users_wiki'](CurrentUser.wiki_id)}` : '',
                isWikiUser: CurrentUser.is_wiki_user,
                managedItemsCount: 0,
                sharedItemsCount: 0,
                myWikis: []
            };
        },
        computed: {
            wikis() {
                return this.results;
            },
            createWikiVisible() {
                return !new CurrentUserClass().is_circle_user();
            },
        },
        methods: {
            changeWikiTemplate(wiki) {
                this.$store.dispatch('WikiStore/changeWikiTemplate', wiki.id)
                    .then(template => {
                        wiki.template = template;
                    }, () => {
                    });
            },
            changeTab(indexFrom, indexTo, done) {
                this.resetResults();
                done();
                this.$nextTick(() => {
                    this.getResults(true);
                });
            },
            getListEndpointArgs() {
                return [];
            },
            getListEndpoint() {
                const WikisListResource = Vue.getAngularModule('WikisListResource');
                if (this.managedItemsCount && !this.sharedItemsCount) {
                    return WikisListResource.get_wikis_i_manage;
                } else if (!this.managedItemsCount && this.sharedItemsCount) {
                    return WikisListResource.get_wikis_shared_with_me_as_read_only;

                } else if (this.managedItemsCount && this.sharedItemsCount) {
                    if (this.tabIndex === 0) {
                        return WikisListResource.get_wikis_i_manage;
                    } else {
                        return WikisListResource.get_wikis_shared_with_me_as_read_only;
                    }
                }

            },
            getAvailableWikisTypes() {
                const UserProfileResource = Vue.getAngularModule('UserProfileResource');
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                return UserProfileResource.get_my_dashboard_state(CurrentUser.id, [DASHBOARD_ITEMS.WIKI])
                    .then(resp => {
                        this.managedItemsCount = resp.data[DASHBOARD_ITEMS.WIKI]['admin'];
                        this.sharedItemsCount = resp.data[DASHBOARD_ITEMS.WIKI]['shared'];
                        if ((this.managedItemsCount === 0) && (this.sharedItemsCount === 0)) {
                            $rootScope.hide_dimmer();
                        }
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    });
            },
            getMyWikis() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const WikiResource = Vue.getAngularModule('WikiResource');
                WikiResource.get_my_wikis()
                    .then(resp => {
                        this.myWikis = resp.data;
                    })
                    .finally(() => {
                        $rootScope.hide_dimmer();
                    });
            },
            createWiki() {
                this.$store.dispatch('WikiStore/createWiki')
                    .then((wikiId) => {
                        this.$router.push({
                            name: getMainWikiPageName(ROUTER_NAME_PREFIX),
                            params: {
                                wikiId,
                                accessCode: this.accessCode
                            },
                            query: {'fl': 1}
                        });
                    });
            }
        },
        mounted() {
            this.getMyWikis();
            this.getAvailableWikisTypes()
                .then(() => {
                    this.$nextTick(() => {
                        if ((this.managedItemsCount === 0) && (this.sharedItemsCount === 0)) {
                            this.allLoaded = true;
                        } else {
                            this.getResults(true);
                        }

                    });
                });
        },
        metaInfo() {
            return {
                title: 'Wikis'
            };
        }
    };
</script>

<style scoped lang="scss">
    .list_header {
        font-size: 21px;
        font-weight: bolder;
    }
</style>
